export default __webpack_public_path__ + "static/media/gi.86bdf46e.svg";